import { Route } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { PROGRAM_ROUTES } from './entities/program/program.route';
import { IFrameComponent } from './shared/component/iframe.component';
import { STUDY_MANAGER_ROUTES } from './study-manager/study-manager.route';
import { GERMPLASM_MANAGER_ROUTES } from './germplasm-manager/germplasm-manager.route';
import { GERMPLASM_LIST_ROUTES } from './germplasm-list/germplasm-list.route';
import { SAMPLE_ROUTES } from './entities/sample';
import { SINGLE_SITE_ANALYSIS_ROUTES } from './single-site-analysis/single-site-analysis.route';
import { ABOUT_ROUTES } from './about/about.route';
import { PROGRAM_SETTINGS_MANAGER_ROUTES } from './program-settings-manager/program-settings-manager.route';
import { CROP_SETTINGS_MANAGER_ROUTES } from './crop-settings-manager/crop-settings-manager.route';
import { SITE_ADMIN_ROUTES } from './site-admin/site-admin.routes';
import { CreateStudyComponent } from './study-editor/create-study/create-study.component';
import { RouteAccessService } from './shared';
import { MULTI_SITE_ANALYSIS_ROUTES } from './multi-site-analysis/multi-site-analysis.route';
import { LABEL_PRINTING_ROUTES } from './label-printing/label-printing.route';
import { DESIGN_CROSSES_ROUTES } from './design-crosses/design-crosses.route';
import { FIELD_MAP_ROUTES } from './study-manager/field-map/field-map.route';
import { MULTI_TRAIT_QUERY_ROUTES } from './multi-trait-query/multi-trait-query.routes';
import { HEAD_TO_HEAD_QUERY_ROUTES } from './head-to-head-query/head-to-head-query.routes';
import { STUDY_EDITOR_ROUTES } from './study-editor/study-editor.route';
import { FIELD_MANAGEMENT_ROUTES } from './field-management/field-management.route';
import { INVENTORY_MANAGER_ROUTES } from './inventory-manager/inventory-manager.module';
import { BRAPI_SYNC_ROUTES } from './brapi-sync/app.route';
import { ONTOLOGY_MANAGER_ROUTES } from './ontology-manager/ontology-manager.route';

export const routes: Route[] = [
    {
        path: '',
        component: NavbarComponent,
        children: [
            {
                path: '',
                redirectTo: 'programs',
                pathMatch: 'full'
            },
            ...PROGRAM_ROUTES,
            ...STUDY_MANAGER_ROUTES,
            ...GERMPLASM_MANAGER_ROUTES,
            ...GERMPLASM_LIST_ROUTES,
            ...SAMPLE_ROUTES,
            ...SINGLE_SITE_ANALYSIS_ROUTES,
            ...MULTI_SITE_ANALYSIS_ROUTES,
            ...ABOUT_ROUTES,
            ...PROGRAM_SETTINGS_MANAGER_ROUTES,
            ...CROP_SETTINGS_MANAGER_ROUTES,
            ...SITE_ADMIN_ROUTES,
            ...LABEL_PRINTING_ROUTES,
            ...DESIGN_CROSSES_ROUTES,
            ...FIELD_MAP_ROUTES,
            ...MULTI_TRAIT_QUERY_ROUTES,
            ...HEAD_TO_HEAD_QUERY_ROUTES,
            ...ONTOLOGY_MANAGER_ROUTES,
            {
                path: 'create-study',
                component: CreateStudyComponent,
                canActivate: [RouteAccessService]
            },
            {
                path: 'study-editor',
                children: [...STUDY_EDITOR_ROUTES]
            },
            {
                path: 'field-management',
                children: [...FIELD_MANAGEMENT_ROUTES]
            },
            {
                path: 'inventory-manager',
                children: [...INVENTORY_MANAGER_ROUTES]
            },
            {
                path: 'brapi-sync',
                children: [...BRAPI_SYNC_ROUTES]
            },
            {
                path: 'default/:url',
                component: IFrameComponent
            }
        ]
    }
];
